import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { getKeycloak } from "@/lib/keycloak";
import { Flex } from "@/components/layout/flex/flex";

const loginSearchSchema = z.object({
	redirect: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/login")({
	component: LoginRedirect,
	validateSearch: zodValidator(loginSearchSchema),
});

function LoginRedirect() {
	const keycloak = getKeycloak();
	const { redirect } = useSearch({ from: "/login" });

	useEffect(() => {
		// If already authenticated, redirect back to intended destination
		if (keycloak.authenticated) {
			window.location.href = redirect || "/";
			return;
		}

		// Redirect to Keycloak login
		void keycloak.login({
			redirectUri: redirect
				? window.location.origin + redirect
				: window.location.origin,
		});
	}, [keycloak, redirect]);

	return (
		<Flex justifyContent="center" alignItems="center" height="100dvh">
			<CircularProgress />
		</Flex>
	);
}
